import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'src/utils/twMerge';
import Button from 'src/designSystem/Button';
import { logAnalyticsEvent } from 'src/modules/analytics/analytics';

type Props = {
  onRetry: () => void;
  screen: string;
  isOnDark?: boolean;
  isGoldRetry?: boolean;
};

const QueryErrorState: FunctionComponent<Props> = ({
  onRetry,
  screen,
  isOnDark = false,
  isGoldRetry = false,
}) => {
  const { t } = useTranslation();

  const handleRetry = () => {
    void logAnalyticsEvent('query_error_retry_clicked', {
      errorScreen: screen,
    });
    onRetry();
  };

  return (
    <div
      className="flex flex-1 flex-col items-center justify-center gap-4 px-4 text-center"
      data-testid="query-error-state"
    >
      <p
        className={twMerge(
          'text-base font-semibold',
          isOnDark ? 'text-white' : 'text-structural-darkest',
        )}
      >
        {t('common.error')}
      </p>
      <Button
        type={isGoldRetry ? 'gold' : 'default'}
        size="middle"
        onClick={handleRetry}
        data-testid="query-error-retry"
      >
        {t('common.retry')}
      </Button>
    </div>
  );
};

export default QueryErrorState;
